import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { fetchAdvisors, getAdvisorsState } from '../../../../../store/slices/catalogSlice';
import AdvisorsGridPlaceholder from '../../../../icons/AdvisorsGridPlaceholder';
import ScrollIntersecting from '../../../ScrollIntersecting';
import Spinner from '../../../Spinner';
import CatalogCard from '../../CatalogCard';
import styles from '../styles.module.scss';

const CatalogList = ({ categoriesParams }) => {
    const { loading, advisorsList, reloading = false, hasMore, currentPage } = useSelector(getAdvisorsState);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    return (
        <>
            {loading && !!reloading && (
                <div className={styles.spinner}>
                    <Spinner />
                </div>
            )}
            {(!loading || !reloading) && !!advisorsList?.length ? (
                <div className={styles.wrapper}>
                    <ScrollIntersecting
                        hasMore={hasMore}
                        fetchFn={() => {
                            if (loading) {
                                return;
                            }
                            dispatch(fetchAdvisors({ categories: categoriesParams, page: currentPage, reloading: false }));
                        }}
                        isReadyForScroll={true}
                    >
                        <div className={styles.grid}>
                            {advisorsList.map((obj) => (
                                <CatalogCard
                                    key={obj.id}
                                    title={obj.name}
                                    text={obj.description}
                                    img={obj.images.avatar}
                                    advisorAlias={obj.alias}
                                    advisorId={obj.id}
                                    isAllowMulti={obj.isAllowMulti}
                                />
                            ))}
                        </div>
                    </ScrollIntersecting>
                </div>
            ) : (
                <div className={styles.empty}>
                    <AdvisorsGridPlaceholder />
                    <p>{t('labels.noAdvisor')}</p>
                </div>
            )}
        </>
    );
};

export default CatalogList;
